import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { versionNum } from '../constants';
import { topAndBottomBarColor } from '../constants/colorsCustom';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    paddingTop: theme.spacing(3),
  },
  appBar: {
    flex: 1,
    position: 'relative',
    flexGrow: 1,
    backgroundColor: topAndBottomBarColor,
    boxShadow: 'none',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    minHeight: '54px',
    height: 'auto',
    backgroundColor: topAndBottomBarColor,
  },
  textTransform: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: 450,
  },
  version: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    fontSize: '12px',
  },
}));

const data = [
  { type: 'normal', display: 'Request a Demo', url: '/contactinfo' },
  { type: 'normal', display: 'Pricing', url: '/contactinfo' },
  { type: 'normal', display: 'Events', url: '/contactinfo' },
  { type: 'normal', display: 'Login', url: '/login' },
  { type: 'normal', display: 'Register Now', url: '/signup' },
  { type: 'normal', display: 'Careers', url: '/contactinfo' },
  { type: 'newTab', display: 'Privacy policy', url: '/privacypolicy' },
  { type: 'newTab', display: 'Terms of service', url: '/termsofservice' },
  { type: 'newTab', display: 'Cookies policy', url: '/cookiepolicy' },
  { type: 'normal', display: 'Contact Us', url: '/contactinfo' },
  {
    type: 'normal',
    display: 'Together Technologies, Inc.',
    url: '/contactinfo',
  },
];

function FooterComp() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar}>
        <div className={classes.container}>
          {data.map((each, index) => {
            switch (each.type) {
              case 'normal':
                return (
                  <IconButton
                    key={index}
                    color='inherit'
                    onClick={() => history.push(each.url)}
                    style={{ padding: 0 }}
                  >
                    <Button color='inherit' disableRipple component='span'>
                      <Typography
                        variant='button'
                        className={classes.textTransform}
                      >
                        {each.display}
                      </Typography>
                    </Button>
                  </IconButton>
                );

              case 'newTab':
                return (
                  <IconButton
                    key={index}
                    color='inherit'
                    onClick={() => window.open(each.url, '_blank')}
                    style={{ padding: 0 }}
                  >
                    <Button color='inherit' disableRipple component='span'>
                      <Typography
                        variant='button'
                        className={classes.textTransform}
                      >
                        {each.display}
                      </Typography>
                    </Button>
                  </IconButton>
                );

              default:
                return null;
            }
          })}
        </div>
        <p className={classes.version}>{versionNum}</p>
      </AppBar>
    </div>
  );
}

export default FooterComp;
